import { ImageVariantEnum, ScreenWidthEnum } from "./enums";
import { ImagesMetrics } from "./types";

export const DATE_FORMATS = Object.freeze({
  DMY: "dd/MM/yyyy",
  HOURS_MINUTES: "HH:mm",
  ISO: "yyyy-MM-dd",
  ORDINAL_DAY_SHORT_MONTH: "do MMM",
  ORDINAL_DAY_LONG_MONTH: "EEEE do MMMM",
  ORDINAL_LONG_MONTH_YEAR: "do MMMM yyyy",
  SHORT_ORDINAL_DAY_SHORT_MONTH: "E do MMM",
  ORDINAL_SHORT_MONTH_DAY: "dd MMM",
} as const);

export const IMAGE_BUCKET =
  "https://storage.googleapis.com/public.yourgolftravel.com/images";

export const IMAGES_METRICS: ImagesMetrics = {
  [ImageVariantEnum.NONE]: {
    [ScreenWidthEnum.BASE]: { width: 184 },
    [ScreenWidthEnum.MOBILE]: { width: 256 },
    [ScreenWidthEnum.TABLET]: { width: 384 },
    [ScreenWidthEnum.DESKTOP]: { width: 512 },
  },
  [ImageVariantEnum.BANNER]: {
    [ScreenWidthEnum.BASE]: { width: 320 },
    [ScreenWidthEnum.MOBILE]: { width: 800 },
    [ScreenWidthEnum.TABLET]: { width: 1200 },
    [ScreenWidthEnum.DESKTOP]: { width: 1920 },
  },
  [ImageVariantEnum.CARD]: {
    [ScreenWidthEnum.BASE]: { height: 240, width: 240 },
    [ScreenWidthEnum.MOBILE]: { height: 320, width: 320 },
  },
  [ImageVariantEnum.CARD2X]: {
    [ScreenWidthEnum.BASE]: { width: 480 },
    [ScreenWidthEnum.MOBILE]: { width: 800 },
    [ScreenWidthEnum.TABLET]: { width: 960 },
  },
  [ImageVariantEnum.FULLWIDTH]: {
    [ScreenWidthEnum.BASE]: { width: 480 },
    [ScreenWidthEnum.MOBILE]: { width: 800 },
    [ScreenWidthEnum.TABLET]: { width: 1200 },
    [ScreenWidthEnum.DESKTOP]: { width: 1920 },
  },
  [ImageVariantEnum.GRID]: {
    [ScreenWidthEnum.BASE]: { width: 480 },
    [ScreenWidthEnum.IPAD_LANDSCAPE]: { width: 320 },
  },
  [ImageVariantEnum.HERO]: {
    [ScreenWidthEnum.BASE]: { ar: "16:9", height: 224 },
    [ScreenWidthEnum.SMALL_TABLET]: { ar: "16:9", height: 288 },
    [ScreenWidthEnum.TABLET]: { ar: "16:9", height: 320 },
    [ScreenWidthEnum.DESKTOP]: { ar: "16:9", height: 384 },
  },
  [ImageVariantEnum.LIGHTBOX]: {
    [ScreenWidthEnum.BASE]: { width: 480 },
    [ScreenWidthEnum.MOBILE]: { width: 800 },
    [ScreenWidthEnum.TABLET]: { width: 960 },
  },
  [ImageVariantEnum.PRIMARY]: {
    [ScreenWidthEnum.BASE]: { width: 480 },
    [ScreenWidthEnum.MOBILE]: { width: 600 },
    [ScreenWidthEnum.TABLET]: { width: 800 },
  },
  [ImageVariantEnum.RADIO]: {
    [ScreenWidthEnum.BASE]: { width: 80 },
    [ScreenWidthEnum.MOBILE]: { width: 120 },
    [ScreenWidthEnum.TABLET]: { width: 160 },
  },
  [ImageVariantEnum.SECONDARY]: {
    [ScreenWidthEnum.BASE]: { width: 480 },
    [ScreenWidthEnum.MOBILE]: { width: 240 },
    [ScreenWidthEnum.SMALL_TABLET]: { width: 360 },
  },
  [ImageVariantEnum.SEARCH]: {
    [ScreenWidthEnum.BASE]: { width: 480 },
    [ScreenWidthEnum.MOBILE]: { height: 240, width: 240 },
  },
  [ImageVariantEnum.SUMMARY]: {
    [ScreenWidthEnum.BASE]: { width: 184 },
  },
  [ImageVariantEnum.THUMBNAIL]: {
    [ScreenWidthEnum.BASE]: { width: 80 },
  },
};

export const TRANSPARENT =
  "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

export const IMAGE_TYPES = ["webp", "jpg"];

export const CLOUDINARY_IMAGE_URL = "https://ygt-res.cloudinary.com/image";
export const PROFILE_PARAM = "profile";
export const PHONE_NUMBER = "0800 043 6644";
export const QUOTE_SESSION_NAME = "quote-session";

export const LOYALTY_CODE_PATTERN = /^LY(-[A-Z]{4}){2}$/i;

export const PROGRESS_MESSAGE = {
  PAX: {
    title: "Updating your best price...",
  },
  DATE: {
    title: "Checking availability...",
  },
  FLIGHT: {
    title: "Finding flights...",
  },
  FLIGHT_TIME: {
    title: "Finalising your itinerary...",
  },
  BOOKING_WITH_FLIGHT: {
    title: "Securing your runways & fairways",
    subTitle:
      "Bundling your flights, hotel & golf into one ATOL-protected trip...",
  },
  BOOKING_NO_FLIGHT: {
    title: "Teeing up your itinerary",
    subTitle: "Verifying your tee times and rooms for the final review...",
  },
  ENQUIRE_NOW: {
    title: "Sending to our Golf Experts",
    subTitle: "We're checking availability to build your custom quote...",
  },
  REVIEW_PACKAGE: {
    title: "Holding your itinerary",
    subTitle:
      "Price & availability locked. Just add your golfer details to secure it...",
  },
  GOLFER_DETAIL: {
    title: "Submitting your scorecard",
    subTitle: "Names, rooms, tee-times confirmed. Loading secure checkout...",
  },
};

export const CLOUDINARY_SRC_PREFIX =
  "https://ygt-res.cloudinary.com/image/upload/v1765796392";

export const CLOUDINARY_AIRLINE_LOGO_PREFIX =
  "https://ygt-res.cloudinary.com/image/upload/v1765796392/airline-logos";
